import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { Auth } from '../auth/auth';

/**
 * Guard para proteger rutas que solo usuarios con login tradicional (email/password) pueden acceder.
 * Los usuarios que iniciaron sesión con PIN (técnicos) solo pueden acceder a /subir-evidencia.
 */
export const nonPinLoginGuard: CanActivateFn = (route, state) => {
  const auth = inject(Auth);
  const router = inject(Router);

  // Si no está autenticado, dejar pasar (authGuard se encargará de redirigir a login)
  if (!auth.isAuthenticated) {
    return true;
  }

  // Si es login con PIN, redirigir a subir-evidencia
  if (auth.isPinLogin) {
    router.navigate(['/subir-evidencia']);
    return false;
  }

  // Login tradicional, puede acceder
  return true;
};
